export const YOURGENAIAPPS = 'your apps'
